import Column from '@components/Column';
import styled from '@emotion/styled';
import { InquiryCommentRow, InquiryResponse } from '@models/inquiry';
import dayjs from 'dayjs';

import InquiryComment from './InquiryComment';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryComments({ inquiry }:Props) {
    const { comments } = inquiry;
    const commentSortFn = (
        a: InquiryCommentRow,
        b: InquiryCommentRow,
    ) => dayjs(a.createdAt).diff(dayjs(b.createdAt));
    const sortedComments = comments.sort(commentSortFn);
    return (
        <Container fullWidth >
            {sortedComments.map((comment) => (
                <InquiryComment key={comment.id} comment={comment}/>
            ))}
        </Container>
    );
}

const Container = styled(Column)`
    margin-bottom: 80px;
`;

export default InquiryComments;
